import { ReactNode, useCallback } from 'react';

import { VisitPrints, VisitPrintsQuery } from '@dreryk/egabinet-visit-frontend-api';

import { ActionEventInterceptor } from '@dreryk/react-components';
import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';

import { recommendationsTranslationKeys } from '../../../../translations';

type RecommendationsPrintActionEventInterceptorProps = Readonly<{
   children: ReactNode;
   visitId: number;
}>;

export const RecommendationsPrintActionEventInterceptor = (
   props: RecommendationsPrintActionEventInterceptorProps
): JSX.Element => {
   const handleRecommendationsPrint = useCallback(async () => {
      const visitPrints = await performCqrsQueryGet<VisitPrints>(() => {
         const query = new VisitPrintsQuery();
         query.prints = {
            otherDocuments: false,
            physicalExamination: false,
            recommendations: true,
            summary: false,
         };
         query.visitId = props.visitId;
         return query;
      });

      await printDocumentAsPdf({ base64: visitPrints.recommendations?.data });
   }, [props.visitId]);

   return (
      <ActionEventInterceptor
         action={handleRecommendationsPrint}
         blockingOperation={recommendationsTranslationKeys.actions.creatingPrint}
      >
         {props.children}
      </ActionEventInterceptor>
   );
};
